import { useSelector } from "react-redux"
import LoginPage from "../scenes/LoginPage.scenes";
import { useLocation } from "react-router-dom";
import { selectHasUserRole, selectUserDetails } from "../store/sessionSelectors";
import { RootState } from "../store/store";
import { UserRole } from "../store/userSlice";

export type AdminRole = UserRole;

interface AdminGuardProps extends React.HTMLAttributes<HTMLElement> {
    allowedRoles?: AdminRole[];
    children: React.ReactNode;
}

export const AdminGuard = ({ children, allowedRoles = ['isAdmin'] }: AdminGuardProps) => {
    const userState = useSelector(selectUserDetails);
    const hasAllowedRole = useSelector((state: RootState) => selectHasUserRole(state, allowedRoles));
    const path = useLocation().pathname;

    if (userState.id && hasAllowedRole) {
        return <>{children}</>;
    }
    return <LoginPage routeBackTo={path} shouldLogout={false} />;
};